import React, { useEffect, useState, useContext } from "react";
import { Pagination } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons";
import { fetchUrl } from "../../config";
import styles from "./OrderSort.module.css";
import SideNav from "../SideNav/SideNav";
import { AllContext } from "../../AllContext";
import BuklStatusUpdate from "../Order/BuklStatusUpdate/BuklStatusUpdate";
import InvoicePdf from "../InvoicePdf/InvoicePdf";
import OrderToSheet from "../OrderToSheet/OrderToSheet";
import OrderListSkeletonApp from "../OrderListSkeleton/OrderListSkeleton";

function OrderSort() {
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const accessToken = localStorage.getItem("access_token");
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [invoice, setInvoice] = useState(false);
  const { setShowAlert, setAlertText, setAlertVariant } =
    useContext(AllContext);

  const { orderSort } = useParams();

  useEffect(() => {
    fetch(
      `${fetchUrl}/api/order/?ordering=-id&page=${currentPage}&search=${orderSort}`,
      {
        headers: { Authorization: `Bearer ${accessToken}` },
      },
    )
      .then((res) => res.json())
      .then((data) => {
        setOrders(data.results);
        setTotalPages(Math.ceil(data.count / 30));
        setLoading(false);
      });
    window.scrollTo(0, 0);
  }, [accessToken, currentPage, orderSort]);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handleUpdateOrderStatus = (id, value) => {
    const orderStatus = new FormData();
    orderStatus.append("order_status", value);
    fetch(`${fetchUrl}/api/order/update/${id}/`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      method: "PATCH",
      body: orderStatus,
    })
      .then((res) => {
        if (res.ok) {
          setShowAlert(true);
          setAlertText(` Update Success`);
          setAlertVariant("success");
        } else {
          setShowAlert(true);
          setAlertText(`Fail to update`);
          setAlertVariant("danger");
        }
      })
      .catch(() => {
        setShowAlert(true);
        setAlertText(`Fail to update`);
        setAlertVariant("danger");
      });
  };
  const handleOrderStatus = (id, e) => {
    // setOrderStatusInput(e.target.value)
    setTimeout(() => {
      handleUpdateOrderStatus(id, e.target.value);
    }, 400);
  };
const [checkArr, setCheckArr] = useState([]);
const [checkAll, setCheckAll] = useState(false);
const [checkArrInv, setCheckArrInv] = useState([]);

// ১. একটি কমন useEffect দিয়ে checkAll হ্যান্ডেল করা সবচেয়ে নিরাপদ এবং রিঅ্যাক্ট স্ট্যান্ডার্ড
useEffect(() => {
  setCheckAll(checkArr.length === orders.length && orders.length > 0);
}, [checkArr, orders]);

// সিগনেচার ঠিক রাখা হলো: handleChecked(data.id, e, data)
const handleChecked = (id, e, data) => {
  const isChecked = e.target.checked;

  if (isChecked) {
    // চেক করলে আইডি এবং অবজেক্ট দুইটাই অ্যাড হবে
    setCheckArr((prev) => [...prev, id]);
    setCheckArrInv((prev) => [...prev, data]);
  } else {
    // আনচেক করলে আইডি এবং অবজেক্ট ফিল্টার হয়ে বাদ যাবে (ফিক্সড)
    setCheckArr((prev) => prev.filter((item) => item !== id));
    setCheckArrInv((prev) => prev.filter((item) => item.id !== id)); // এখানে .id যুক্ত করা হয়েছে
  }
};

const handleCheckAll = (e) => {
  const { checked } = e.target;
  setCheckAll(checked);

  if (checked) {
    // সিলেক্ট অল করলে আইডি এবং পুরো অবজেক্ট দুটোই সেভ হবে (ফিক্সড)
    setCheckArr(orders.map((o) => o.id));
    setCheckArrInv([...orders]);
  } else {
    // আনচেক অল করলে সব খালি হয়ে যাবে
    setCheckArr([]);
    setCheckArrInv([]);
  }
};

  return (
    <div>
      <div className="NavRow">
        <div>
          <SideNav />
        </div>
        <div className="bodyLayout ">
          <div>
            <h3 className="text-center">Order List</h3>
            <div className={styles.CustomTable}>
              <div className={styles.CustomTable2nd}>
                <div className={styles.cutomRowHeader}>
                  <div className={styles.cutomHeader}>SL</div>
                  <div className={styles.cutomHeader}>Order Id</div>
                  <div className={styles.cutomHeader}>Name</div>
                  <div className={styles.cutomHeader}>Phone</div>
                  <div className={styles.cutomHeader}>Address</div>
                  <div className={styles.cutomHeader}>Note</div>
                  <div className={styles.cutomHeader}>Product</div>
                  <div className={styles.cutomHeader}>Status</div>
                </div>
                <div>
                  {loading ? (
                    <OrderListSkeletonApp />
                  ) : (
                    <div>
                      {orders && orders.length > 0 ? (
                        orders.map((data, index) => (
                          <div key={data.id}>
                            <div className={styles.cutomRow}>
                              <div className={styles.cutomRowData}>
                                {" "}
                                {edit || invoice ? (
                                  <input
                                    checked={checkArr.includes(data.id)}
                                    onChange={(e) =>
                                      handleChecked(data.id, e, data)
                                    }
                                    className="form-check-input"
                                    type="checkbox"
                                    name="orderid"
                                    id="orderid"
                                  />
                                ) : (
                                  index + 1
                                )}
                              </div>
                              <div className={styles.cutomRowData}>
                                <Link
                                  className={`${styles.order_link}`}
                                  to={`/order/${data.order_id}`}
                                >
                                  {data.order_id}
                                </Link>
                              </div>
                              <div className={styles.cutomRowData}>
                                {data.name.slice(0, 15)}
                              </div>
                              <div className={styles.cutomRowData}>
                                <a
                                  className=" text-decoration-none text-dark"
                                  href={`tel:${data.phone}`}
                                >
                                  {data.phone}
                                </a>{" "}
                                <span>
                                  {data.old_customer ? (
                                    <FontAwesomeIcon
                                      className="text-danger"
                                      icon={faLightbulb}
                                    />
                                  ) : null}
                                </span>
                              </div>
                              <div className={styles.cutomRowData}>
                                {data.address.slice(0, 30)}
                              </div>
                              <div className={styles.cutomRowData}>
                                <small>
                                  {data.note && data.note.slice(0, 32)}
                                </small>
                              </div>
                              <div className={styles.cutomRowData}>
                                {data.products.slice(0, 20)}
                              </div>
                              <div className={styles.cutomRowData}>
                                <select
                                  className={styles.select}
                                  name="order-status"
                                  onChange={(e) =>
                                    handleOrderStatus(data.id, e)
                                  }
                                  defaultValue={data.order_status}
                                >
                                  <option value="New">New</option>
                                  <option value="Pending">Pending</option>
                                  <option value="Cancelled">Cancelled</option>
                                  <option value="Confirmed">Confirmed</option>
                                  <option value="Courier">Courier</option>
                                  <option value="Delivered">Delivered</option>
                                  <option value="Return">Return</option>
                                  <option value="Money Collected">
                                    Money Collected
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-3 border-bottom">
                          কোনো অর্ডার পাওয়া যায়নি!!
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div>
            {orders && orders.length > 0 && (
              <div>
                <div className={styles.pagination}>
                  <Pagination>
                    <Pagination.First onClick={() => setCurrentPage(1)} />
                    <Pagination.Prev
                      onClick={handlePrevPage}
                      disabled={currentPage === 1}
                    />

                    {currentPage > 3 && <Pagination.Ellipsis />}
                    {currentPage > 2 && (
                      <Pagination.Item
                        onClick={() => setCurrentPage(currentPage - 2)}
                      >
                        {currentPage - 2}
                      </Pagination.Item>
                    )}
                    {currentPage > 1 && (
                      <Pagination.Item
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        {currentPage - 1}
                      </Pagination.Item>
                    )}

                    <Pagination.Item active>{currentPage}</Pagination.Item>

                    {currentPage < totalPages && (
                      <Pagination.Item
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        {currentPage + 1}
                      </Pagination.Item>
                    )}
                    {currentPage < totalPages - 1 && (
                      <Pagination.Item
                        onClick={() => setCurrentPage(currentPage + 2)}
                      >
                        {currentPage + 2}
                      </Pagination.Item>
                    )}
                    {currentPage < totalPages - 2 && <Pagination.Ellipsis />}

                    <Pagination.Next
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last
                      onClick={() => setCurrentPage(totalPages)}
                    />
                  </Pagination>
                </div>
                <BuklStatusUpdate
                  checkAll={checkAll}
                  handleCheckAll={handleCheckAll}
                  edit={edit}
                  setEdit={setEdit}
                  checkArr={checkArr}
                  setCheckArr={setCheckArr}
                />
                <InvoicePdf
                  edit={edit}
                  invoice={invoice}
                  setInvoice={setInvoice}
                  checkArrInv={checkArrInv}
                />
                <OrderToSheet />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderSort;
